import ReactDOM from 'react-dom';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useThree } from 'react-three-fiber';
import { Fab } from '@material-ui/core';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';

// modeled after https://github.com/pmndrs/drei/blob/master/src/Html.tsx

const Download = () => {
  const { gl } = useThree();
  const [element] = useState(() => {
    const div = document.createElement('div');
    document.body.appendChild(div);
    return div;
  });

  const linkRef = useRef();
  const download = useCallback(() => {
    gl.domElement.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      linkRef.current.href = url;
      linkRef.current.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }, 'image/png');
  }, [gl]);

  useEffect(() => {
    ReactDOM.render(
      <div className="download">
        <a href="/" download="kaleidoscope.png" ref={linkRef} style={{ opacity: 0, fontSize: 0 }}>
          Download
        </a>
        <Fab onClick={download} size="medium" title="Download">
          <PhotoCameraIcon />
        </Fab>
      </div>,
      element,
    );
  }, [element, download]);

  return null;
};

export default Download;
